import { Component, OnInit, ViewChild,ElementRef, OnDestroy } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';


@Component({
  selector:'app-merchant-enquiry',
  templateUrl:'./merchant-enquiry.component.html',
  styleUrls:['./merchant-enquiry.component.scss']
})
export class MerchantEnquiryComponent implements OnInit, OnDestroy{


merchantId:any;

enquiries:any[]=[];

selectedEnquiry:any=null;

replyMessage:string='';
@ViewChild('chatContainer')
chatContainer!: ElementRef;
showServiceDetails = false;

refreshInterval:any;


constructor(
private apiService:ApiServiceService
){}



ngOnInit(){

this.merchantId =
localStorage.getItem('merchantId');


this.loadEnquiries();
this.refreshInterval =
setInterval(()=>{

this.refreshChat();

},5000);

}




loadEnquiries(){


this.apiService
.getMerchantEnquiries(this.merchantId)
.subscribe({

next:(res:any)=>{

console.log("Merchant Enquiries", res);
this.enquiries =
res.data || [];


// auto select first enquiry

// if(this.enquiries.length){

//   this.selectEnquiry(this.enquiries[0]);

// }


},


error:(err)=>{

console.log(err);

}


});


}

refreshChat(){


if(!this.selectedEnquiry){

return;

}



this.apiService
.getMerchantEnquiries(this.merchantId)
.subscribe({

next:(res:any)=>{


const updatedList = res.data || [];


// update left enquiry list

this.enquiries = updatedList;



const updated =
updatedList.find(
(e:any)=>
e._id === this.selectedEnquiry._id
);



if(updated){


this.selectedEnquiry = updated;



// setTimeout(()=>{

// this.scrollToBottom();

// },100);


}



},

error:(err)=>{

console.log(err);

}

});


}

scrollToBottom(){


if(this.chatContainer){


const element =
this.chatContainer.nativeElement;


element.scrollTop =
element.scrollHeight;


}


}


selectEnquiry(enquiry:any){

  this.selectedEnquiry = enquiry;
  setTimeout(()=>{

this.scrollToBottom();

},200);

  // Clear unread messages

  this.apiService
  .markMerchantRead(enquiry._id)
  .subscribe({

    next:(res:any)=>{

      enquiry.merchant_unread_count = 0;

    },

    error:(err)=>{

      console.log(err);

    }

  });

}







sendReply(){


if(!this.replyMessage.trim()){

return;

}



const data={


sender_type:"MERCHANT",


sender_id:this.merchantId,


message:this.replyMessage


};



this.apiService
.replyServiceEnquiry(
this.selectedEnquiry._id,
data
)
.subscribe({

next:(res:any)=>{


this.selectedEnquiry =
res.data;


this.replyMessage='';


this.loadEnquiries();


},


error:(err)=>{

console.log(err);

}

});


}

closeTicket(){


if(!this.selectedEnquiry){

return;

}



const confirmClose =
confirm(
"Close this enquiry?"
);



if(!confirmClose){

return;

}



this.apiService
.closeServiceEnquiry(
this.selectedEnquiry._id
)
.subscribe({

next:(res)=>{


this.selectedEnquiry=null;


this.loadEnquiries();


},


error:(err)=>{

console.log(err);

}

});


}
ngOnDestroy(){


if(this.refreshInterval){

clearInterval(this.refreshInterval);

}


}
openServiceDetails(){

  this.showServiceDetails = true;

}


closeServiceDetails(){

  this.showServiceDetails = false;

}

}